// A store may have more than one mounted JobHandler (for example a sales page
// and its SoldToShipTo child). Own initialization across those hook instances.
const stores = new WeakMap();
export function acquireJobInitialization(dispatch, key) {
  let active = stores.get(dispatch);
  if (!active) { active = new Set(); stores.set(dispatch, active); }
  if (active.has(key)) return null;
  active.add(key);
  let released = false;
  return () => {
    if (!released) { released = true; active.delete(key); }
  };
}
